/**
 * @author James Adams
 */
function MagicSpellState(id){
  this.createPageState(id,{
    sort:[],
    filter:{},
    columnView:{},
    columnOrder:[],
    selection:[]
  });
}

export default MagicSpellState;
